import { action, makeObservable, runInAction } from 'mobx';

import { ENDPOINTS } from '@/configs/endpoints';
import { FollowUpEntity } from '@/entities/FollowUp';
import { notificationsStore } from '@/stores/global/RootStore';
import { ILocalStore } from '@/stores/interfaces/ILocalStore';
import { MetaStore } from '@/stores/local/shared/MetaStore';
import call from '@/utils/api/api';

type UpdateFollowUpStoreParams = {
  organizationId: string;
  onSuccess: (withMeta?: boolean) => Promise<void>;
};

export class UpdateFollowUpStore implements ILocalStore {
  readonly meta = new MetaStore();
  private _organizationId: UpdateFollowUpStoreParams['organizationId'];

  private readonly _onSuccess: UpdateFollowUpStoreParams['onSuccess'];

  constructor({ organizationId, onSuccess }: UpdateFollowUpStoreParams) {
    this._organizationId = organizationId;
    this._onSuccess = onSuccess;

    makeObservable(this, {
      update: action.bound,
    });
  }

  update = async (model: FollowUpEntity) => {
    this.meta.setLoadedStartMeta();

    const response = await call({
      endpoint: ENDPOINTS.followUp.update(this._organizationId, model.id),
      method: 'PUT',
      data: {
        is_done: model.isDone ? false : true,
      },
    });

    if (response.isError) {
      const errorText = model.isDone ? 'Не удалось вернуть в открытые' : 'Не удалось закрыть follow-up';

      notificationsStore.showError(response.error.message ?? errorText);
      this.meta.setLoadedErrorMeta();

      return;
    }

    runInAction(() => {
      this._onSuccess(false);
      this.meta.setLoadedSuccessMeta();
    });
  };

  destroy() {
    this.meta.destroy();
  }
}
